import React, { useEffect, useRef } from 'react';
import { Platform, View } from 'react-native';
import Text from '@/components/Typography/Text';
import { useLanding } from '@/components/Landing/LandingKit';
import { PricingSection, PricingTitle } from './PricingKit';
import BusinessSeatCalculator from '@/components/Business/BusinessSeatCalculator';
import BusinessCta from '@/components/Business/BusinessCta';
import useBusinessBrand from '@/components/Business/businessBrand';
import useBusinessEnrollment from '@/components/Business/useBusinessEnrollment';
import { businessCopy } from '@/constants/businessContent';

export default function PricingBusiness() {
  const { isCompact } = useLanding();
  const c = useBusinessBrand();
  const copy = businessCopy(useBusinessEnrollment());
  const sectionRef = useRef(null);
  useEffect(() => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return undefined;
    let frame;
    const scrollToBusiness = () => {
      if (window.location.hash !== '#business') return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => sectionRef.current?.scrollIntoView?.({ block: 'start' }));
    };
    scrollToBusiness();
    window.addEventListener('hashchange', scrollToBusiness);
    return () => { cancelAnimationFrame(frame); window.removeEventListener('hashchange', scrollToBusiness); };
  }, []);
  if (Platform.OS !== 'web') return null;
  return (
    <PricingSection label="Gab AI Business">
      <View ref={sectionRef} nativeID="business" style={{ flexDirection: isCompact ? 'column' : 'row', gap: 48, scrollMarginTop: 100, alignItems: isCompact ? 'stretch' : 'center' }}>
        <View style={{ flex: 1, gap: 16 }}>
          <Text weight="medium" style={{ color: c.muted, fontSize: 14 }}>Gab AI Business{copy.availability ? ` · ${copy.availability}` : ''}</Text>
          <PricingTitle>Better, together.</PricingTitle>
          <Text style={{ color: c.muted, fontSize: 17, lineHeight: 27, maxWidth: 470 }}>One company bill. Shared credits. A seat for everyone on your team.</Text>
          <Text style={{ color: c.muted, fontSize: 15, lineHeight: 24 }}>{copy.pricingDetail}</Text>
          <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 12 }}>
            {copy.primary && <BusinessCta label={copy.primary.label} href={copy.primary.href} />}
            <BusinessCta label={copy.primary ? 'Learn about Business' : 'Explore Gab AI Business'} href="/business" secondary />
          </View>
        </View>
        <View style={{ flex: 1 }}><BusinessSeatCalculator /></View>
      </View>
    </PricingSection>
  );
}
